import { Entry } from "./Data.js"

export type CountryCode = string

interface VotingData {
	year: number
	point?: boolean
	tele?: boolean
	jury?: boolean
	winner?: CountryCode[]
	last?: CountryCode[]
	ongoing: boolean
	octopus: boolean
	event: number
	type: number
	status: number
	status_sub: number[]
	ongoing_sub: (number | boolean)[]
}

type VotingSongs = {
	// [artist, song, ?]
	[country: CountryCode]: [string, string, boolean]
}

type VotingTableMain = {
	// [running, place, total points, tele points, jury points, in final, semifinal]
	[country: CountryCode]: [number, number, number, number, number, boolean, number]
}

type VotingTableSub = {
	// [running, place, total points, tele points, jury points, in final, semifinal, semifinal place]
	[country: CountryCode]: [number, number, number, number, number, boolean, number, number]
}

type AllData = {
	data: VotingData
	songs: VotingSongs
	table_main: VotingTableMain
	table_main_arr: CountryCode[]
	table_sub: VotingTableSub[]
	table_sub_arr: CountryCode[][]
	point: [CountryCode, CountryCode, number, number, number][]
	jurymembers: any
}

export default class EurovisionworldAPI {
	year: number

	data: VotingData
	songs: VotingSongs
	table_main: VotingTableMain
	table_main_arr: CountryCode[]
	table_sub: VotingTableSub[]
	table_sub_arr: CountryCode[][]

	constructor(year: number) {
		this.year = year
	}

	async init() {
		const data: AllData = await fetch(EurovisionworldAPI.getURL(this.year)).then(x => x.json())

		this.data = data.data
		this.songs = data.songs
		this.table_main = data.table_main
		this.table_main_arr = data.table_main_arr
		this.table_sub = data.table_sub
		this.table_sub_arr = data.table_sub_arr
	}

	getEntries(votingTable: VotingTableMain | VotingTableSub): Entry[] {
		return Object.entries(votingTable)
			.map(([country, votingData]) => ({
				nr: votingData[0],
				country: country,
				song: this.songs[country][1],
				artist: this.songs[country][0],
				place: votingData[1]
			}))
	}

	getFinalEntries = () => this.getEntries(this.table_main)
	getSemifinal1Entries = () => this.getEntries(this.table_sub[0] ?? {})
	getSemifinal2Entries = () => this.getEntries(this.table_sub[1] ?? {})

	// Content comes from https://static.eurovisionworld.com/js/voting/140.js
	static getURL(year: number) {
		return `data/${year}.json`
	}

}
